import { INPUT_TYPE } from "../../constants/Constant";


export const FORM_FIELDS = [
    {
        columnCode: "payscheduleName",
        editable: true,
        hidden: false,
        id: "payscheduleName",
        index: 0,
        name: "Payschedule Name",
        validator: [{key:"required", value: true}] ,
        type: "text",
        uiVisible: true,
        direction: "HORIZONTAL",
    },
    {
        columnCode: "payPeriod",
        editable: true,
        hidden: false,
        id: "payPeriod",
        index: 1,
        name: "Pay Period",
        validator: [{key:"required", value: true}] ,
        type: INPUT_TYPE.DROPDOWN,
        uiVisible: true,
        direction: "HORIZONTAL",
        options: []
    },
    {
        columnCode: "payDay",
        editable: true,
        hidden: false,
        id: "payDay",
        index: 2,
        name: "Pay Day",
        validator: [{key:"required", value: true}] ,
        type: INPUT_TYPE.DROPDOWN,
        uiVisible: true,
        direction: "HORIZONTAL",
        options: []
    },
    {
        columnCode: "location",
        editable: true,
        hidden: false,
        id: "location",
        index: 3,
        name: "Location",
        validator: [{key:"required", value: false}] ,
        type: INPUT_TYPE.DROPDOWN,
        uiVisible: false,
        direction: "HORIZONTAL",
        options: []
    },
    {
        columnCode: "applicableToAll",
        editable: true,
        hidden: false,
        id: "applicableToAll",
        index: 4,
        name: "Applicable To All",
        validator: [{key:"required", value: true}] ,
        type: INPUT_TYPE.DROPDOWN,
        uiVisible: true,
        direction: "HORIZONTAL",
        options: [{id:"true", name: "Yes"},{id:"false", name: "No"}]
    },
    {
        columnCode: "employees",
        editable: true,
        hidden: false,
        id: "employees",
        index: 5,
        name: "Users",
        validator: [{key:"required", value: true}] ,
        type: INPUT_TYPE.DROPDOWN,
        uiVisible: true,
        direction: "HORIZONTAL",
        options: [],
        isMultiSelect: true
    }
]